/* RYŌHŌ — CHANTIER B / C1 + C2 — Sélecteur d'offres et synchronisation de l'affichage.

   C1 : l'option choisie réécrit la valeur de l'input caché [name="id"] du formulaire
        produit existant. Rien d'autre. L'ajout au panier reste celui de Dawn
        (product-form.js -> FormData -> /cart/add), donc tiroir panier, tracking et
        applications tierces sont inchangés.

   C2 : la barre collante n'a pas de formulaire propre (elle relaie le clic vers le vrai
        bouton) — le bon produit part donc TOUT SEUL. Il ne reste qu'à refléter le nom
        et le prix de l'option choisie.

   RÈGLE : tout ce qui est affiché doit correspondre à ce qui sera facturé. On resynchronise
   donc AUSSI le bloc prix principal, le badge d'économie, la ligne de composition et la
   ligne « acheté séparément » — sinon une cliente sur desktop (où la barre collante
   n'existe pas) lirait le prix du Glow Pro tout en achetant le Rituel Intégral.

   Aucun montant n'est écrit en dur ici : toutes les valeurs viennent d'attributs data-*
   rendus côté Liquid depuis les objets produit. */

(function () {
  'use strict';

  var FIELDSET = '[data-ryb-offers]';

  /* Le formulaire est cherché DANS le <product-info> qui contient le sélecteur, pas dans
     tout le document : une fiche peut porter d'autres formulaires produit injectés avant
     le nôtre (quick-add, upsell tiers), qui capteraient le querySelector global. */
  function scope(root) {
    return root.closest('product-info') || root.closest('.product') || document;
  }

  function form(root) {
    return scope(root).querySelector('product-form form[data-type="add-to-cart-form"]');
  }

  function variantInput(root) {
    var f = form(root);
    // Même sélecteur que le getter variantIdInput de Dawn (product-form.js).
    return f ? f.querySelector('[name=id]') : null;
  }

  function selected(root) {
    return root.querySelector('input[name="ryb-offer"]:checked');
  }

  function setText(el, value) {
    if (el) el.textContent = value;
  }

  /* Bloc prix principal (snippets/price.liquid).
     ATTENTION à l'ordre du DOM : le 1er .price-item--regular est le PRIX COURANT
     (.price__regular) ; le prix barré est le <s class="price-item--regular"> de
     .price__sale. Un sélecteur nu prendrait le mauvais. */
  function syncMainPrice(root, radio) {
    var sc = scope(root);
    var price = radio.dataset.price || '';
    var compare = radio.dataset.compare || '';

    setText(sc.querySelector('.price__regular .price-item--regular'), price);
    setText(sc.querySelector('.price__sale .price-item--sale'), price);
    setText(sc.querySelector('.price__sale s.price-item--regular'), compare);

    // Badge d'économie « −52 € » : le libellé masqué « Économie de » est conservé.
    var save = sc.querySelector('.ryoho-save');
    if (save) {
      var hidden = save.querySelector('.visually-hidden');
      save.textContent = '';
      if (hidden) save.appendChild(hidden);
      if (radio.dataset.save) {
        save.insertAdjacentHTML('beforeend', radio.dataset.save);
        save.hidden = false;
      } else {
        save.hidden = true;
      }
    }

    // Lignes de contexte : elles décrivent le contenu de l'offre, elles doivent suivre.
    /* Deux lignes de composition coexistent : la longue (desktop) et la courte (mobile).
       La CSS n'en affiche qu'une ; le script les alimente toutes les deux, chacune avec
       sa donnée, pour qu'un changement de formule les mette à jour ensemble. */
    sc.querySelectorAll('.ryb-compo--court').forEach(function (n) {
      var t = radio.dataset.compoCourt || radio.dataset.compo || '';
      setText(n, t);
      n.hidden = !t;
    });
    var compo = sc.querySelector('.ryb-compo:not(.ryb-compo--court)');
    if (compo) {
      setText(compo, radio.dataset.compo || '');
      compo.hidden = !radio.dataset.compo;
    }
    var sep = sc.querySelector('.ryb-sep');
    if (sep) {
      setText(sep, radio.dataset.sep || '');
      sep.hidden = !radio.dataset.sep;
    }
  }

  /* Bloc « Inclus dans … » (contrat B9). Les trois panneaux sont rendus par Liquid ; on
     n'en laisse visible que celui de la formule cochée.

     Si le panneau de la formule choisie n'existe pas — le panneau Rituel Intégral n'est
     émis que si `serum-deep-collagen` est publié, alors que l'offre, elle, reste
     achetable — on masque TOUT LE BLOC. Afficher le panneau du Glow Pro sous une formule
     à 139,90 € montrerait un contenu qui n'est pas celui facturé : exactement la
     désynchronisation que ce fichier existe pour empêcher. */
  function syncInclus(radio) {
    var bloc = document.querySelector('[data-ry-inclus]');
    if (!bloc) return;
    var panneaux = bloc.querySelectorAll('[data-ry-inclus-panel]');
    if (!panneaux.length) return;
    var voulu = radio.dataset.handle;
    var trouve = false;
    panneaux.forEach(function (panneau) {
      var actif = panneau.dataset.ryInclusPanel === voulu;
      if (actif) trouve = true;
      panneau.hidden = !actif;
    });
    bloc.hidden = !trouve;
    /* Passe corrective 09/2026 : le bloc vit désormais dans un enrobage qui porte aussi
       le bouton « Voir ce qui est inclus ». Masquer le seul panneau laisserait un bouton
       qui n'ouvre plus rien — on masque donc l'enrobage entier. */
    var enrobage = bloc.closest('[data-ry-inclus-wrap]');
    if (enrobage) enrobage.hidden = !trouve;
  }

  function syncSticky(radio) {
    var bar = document.querySelector('sticky-atc');
    if (!bar) return;

    setText(bar.querySelector('[data-sticky-name]'), radio.dataset.name || '');

    var priceSlot = bar.querySelector('[data-sticky-price]');
    if (!priceSlot) return;
    priceSlot.textContent = '';

    var now = document.createElement('span');
    now.className = 'sticky-atc__price';
    now.textContent = radio.dataset.price || '';
    priceSlot.appendChild(now);

    if (radio.dataset.compare) {
      var was = document.createElement('s');
      was.className = 'sticky-atc__compare';
      was.textContent = radio.dataset.compare;
      priceSlot.appendChild(was);
    }
  }

  function apply(root) {
    var radio = selected(root);
    if (!radio) return;

    var input = variantInput(root);
    if (input) {
      input.value = radio.value;
      // L'input est rendu `disabled` par buy-buttons.liquid quand la variante par défaut
      // est indisponible : il faut le réactiver, sinon FormData l'ignore et /cart/add
      // repart sans identifiant.
      input.removeAttribute('disabled');
      input.disabled = false;
    }

    /* Le bouton d'ajout est désactivé par Liquid selon la disponibilité du produit
       COURANT. Si le Glow Pro venait à être épuisé, les autres offres — pourtant
       disponibles — deviendraient inachetables. Le sélecteur ne rend que des offres
       disponibles : si l'une est choisie, l'ajout doit être possible.
       Dawn signale « envoi en cours » via aria-disabled, pas via disabled : on ne
       marche donc pas sur l'état transitoire de soumission. */
    var f = form(root);
    var submit = f ? f.querySelector('[type="submit"]') : null;
    if (submit && submit.disabled) {
      submit.disabled = false;
    }
    /* Le libellé porte le prix de l'offre choisie (contrat B10) : il doit suivre à
       CHAQUE changement, pas seulement quand le bouton était désactivé. On ne touche
       pas au libellé d'une offre indisponible — son bouton annonce « Épuisé ». */
    if (submit && !submit.disabled && radio.dataset.atcLabel) {
      var span = submit.querySelector('span');
      if (span) span.textContent = radio.dataset.atcLabel;
    }

    root.querySelectorAll('.ryb-offer').forEach(function (label) {
      var r = label.querySelector('input[name="ryb-offer"]');
      label.classList.toggle('is-selected', !!r && r.checked);
    });

    syncMainPrice(root, radio);
    syncInclus(radio);
    syncSticky(radio);
  }

  function init(root) {
    if (root.dataset.rybReady === '1') return;
    root.dataset.rybReady = '1';
    root.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'ryb-offer') apply(root);
    });
    apply(root);
  }

  function boot() {
    document.querySelectorAll(FIELDSET).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Dawn peut remplacer <product-info> (changement de variante, combined listings) :
     l'input caché est alors RECRÉÉ avec la variante par défaut et notre choix est perdu.

     On ne réagit qu'à ce cas précis — le remplacement du NŒUD input — et jamais à un
     simple changement de valeur sur le même nœud. Sans cette distinction, le sélecteur
     de variantes de Dawn ne pourrait plus rien écrire : nous réécririons sa valeur à
     chaque frappe, et la variante choisie par la cliente n'atteindrait jamais /cart/add. */
  var lastInput = new WeakMap();
  document.querySelectorAll(FIELDSET).forEach(function (root) {
    lastInput.set(root, variantInput(root));
  });

  var mo = new MutationObserver(function () {
    document.querySelectorAll(FIELDSET).forEach(function (root) {
      var input = variantInput(root);
      if (!input) return;
      if (lastInput.get(root) !== input) {
        lastInput.set(root, input);
        apply(root);
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
